import { RouteObject } from 'react-router-dom';
import loadable from '@loadable/component';

import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

const ReferralOutboundPage = loadable(
  () => import('@/pages/CRM/ReferralOutbound/ReferralOutboundPage')
); // prettier-ignore

const CreateReferralWizard = loadable(
  () => import('@/pages/CRM/ReferralOutbound/CreateReferralWizard')
); // prettier-ignore

export enum CRMReferralOutboundRoutes {
  CRMReferralOutbound = '/crm/referral-outbound',
  CRMReferralOutboundSend = '/crm/referral-outbound/send'
}

export const getCrmReferralOutboundRoutes = (): RouteObject[] => {
  if (!FeatureFlagService.isEnabled(ExacareFeature.CRM_REFERRAL_OUTBOUND)) {
    return [];
  }
  return [
    {
      path: CRMReferralOutboundRoutes.CRMReferralOutbound,
      element: <ReferralOutboundPage />
    },
    {
      path: CRMReferralOutboundRoutes.CRMReferralOutboundSend,
      element: <CreateReferralWizard />
    }
  ];
};
